<template>
    <div>
        <v-dialog v-model="isDialog" :width="width" :persistent="true" style="z-index:1005;">
            <v-card>
                <div class="header-container">
                    <p class="header-title">{{ header }}</p>
                    <div>
                        <div class="close-dialog-btn" @click="isDialog=false"><i class="fas fa-times" /></div>
                    </div>
                </div>

                <div class="card-content">
                    <slot name="content" />
                </div>

                <v-card-actions class="card-action">
                    <div class="flex-grow-1" />
                    <slot name="action" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: "55%"
        },
        header: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            isDialog: false
        };
    },
    watch: {
        isDialog() {
            if (this.isDialog == false) {
                this.$emit("update:dialog", false);
            }
        },
        dialog() {
            this.isDialog = this.dialog;
        },
    },
    methods: {
			
    }
};
</script>

<style scoped>
.header-container{
	background-color: var(--main-color);
	padding: 8px 16px;
	font-size: 16px;
	color: var(--pure-white);
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header-title{
	margin: 0;
    color: white;
}
.card-content{
    padding: 16px;
	color: rgba(0, 0, 0, 0.6);
	min-height: 100px;
	font-size: 15px;
	border-bottom: 1px solid var(--dialog-separator-line);
}
.card-action{
	padding: 16px;
}
.close-dialog-btn{
	border-radius: 50%;
	padding: 9px;
	background-color: var(--main-color-orange);
	width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
	justify-content: center;
	font-size: 10px;
	cursor: pointer;
}
.close-dialog-btn:hover{

}
</style>


// WEBPACK FOOTER //
// src/smallComponents/GeneralDialog.vue